import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../css/banner.css";

export default function Banner() {
  return (
    <section className="prefooter-gradient">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <p className="prefooter-gradient__text">
              “Progress is progress, no matter how small.”
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
